import { useEffect } from "react";
//import { Link } from "react-router-dom";
import { API_URL } from "../config";

const Logout = () => {
  

useEffect(() => {
  fetch(`${API_URL}/api-logout.php`, {
    method: "POST",
    credentials: "include",
  })
    .then(res => res.json())
    .then(data => {
      console.log(data);

      // Clear frontend storage
      localStorage.removeItem("user");
      sessionStorage.clear();

      // Force reload (important)
      window.location.reload();
    })
    .catch(err => console.log(err));
}, []);

useEffect(() => {
  fetch(`${API_URL}/api-check-session.php`, {
    method: "GET",
    credentials: "include",
  })
    .then(res => res.json())
    .then(data => {
      console.log("Session check:", data);

      if (!data.loggedIn) {
        // If session destroyed → redirect
        window.location.href = "/login?action=logout";
      }
    })
    .catch(err => console.log(err));
}, []);




  return (
    <div>
    </div>
  );
};

export default Logout;